import React from 'react'
import Auth from './Auth'
import Data from './Data'

const AppProviders = ({ children }) => {
    return (
        <Auth>
            <Data>
                {children}
            </Data>
        </Auth>
    )
}

export default AppProviders